import '@/styles/globals.css'
import '@/styles/rich-text.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { MotionConfig } from 'motion/react'
import { SmoothScroll } from '@/components/motion/smooth-scroll'
import { Cursor } from '@/components/generals/cursor'
import { PageTransition } from '@/components/generals/page-transition'

import {
    Archivo,
    Instrument_Serif,
    JetBrains_Mono,
    Manrope
} from 'next/font/google'

const sans = Manrope({
    subsets: ['latin']
})

const heading = Archivo({
    subsets: ['latin'],
    axes: ['wdth']
})

const serif = Instrument_Serif({
    subsets: ['latin'],
    weight: '400',
    style: ['normal', 'italic']
})

const mono = JetBrains_Mono({
    subsets: ['latin']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily};--font-app-serif:${serif.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <MotionConfig reducedMotion='user'>
                <SmoothScroll>
                    <Component {...pageProps} />
                    <PageTransition />
                    <Cursor />
                </SmoothScroll>
            </MotionConfig>
        </div>
    )
}

export default App
